import React from "react";
import PropType from "prop-types";

import { MyButton } from "./styles";

function Button(props) {
  return <MyButton {...props} />;
}

Button.propTypes = {
  primary: PropType.bool,
};

export default Button;
